import { UserActionTypes } from './user.types';

const INITIAL_STATE = {
    auth: '',
    adminList: [],
    groupList: []
};

const userReducer = (state = INITIAL_STATE, action: any) => {
    switch (action.type) {
        case UserActionTypes.LOGIN_SUCCESS:
        case UserActionTypes.REFRESH_TOKEN:
            return {
                ...state,
                auth: action.payload

            };
        case UserActionTypes.LOGOUT_SUCCESS:
            return {
                ...state,
                auth: ''
            };
        case UserActionTypes.LOGIN_FAIL:
        case UserActionTypes.LOGOUT_FAIL:
            return {
                ...state,
                auth: ''
            };
        default:
            return state;
    }
};

export default userReducer;
